import Vue from 'vue';
import Router from 'vue-router';

import { routes } from './routes';
import { AuthService } from '../services/auth.service';
import $store from "../store";
import NProgress from 'nprogress';

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  const currentUserId = $store.state.user.currentUser.id;
  router.app.$log.debug('User', currentUserId);

  if (AuthService.getRefreshToken() && !currentUserId) {
    router.app.$log.info('Refresh access token');

    return AuthService.refreshTokens()
        .then(() => $store.dispatch('user/GET'))
        .then(() => next())
        .catch(error => router.app.$log.fatal(error))
  }
  next();
});

router.beforeEach((to, from, next) => {
  const currentUserId = $store.state.user.currentUser.id || 0;
  const isAuthRoute = to.matched.some(item => item.meta.isAuth);

  if (isAuthRoute && currentUserId) {
    router.app.$log.info('User is authorized');
    return next();
  }
  if (isAuthRoute) {
    router.app.$log.info('Authorization required');
    return next({ name: 'login' });
  }

  router.app.$log.info('No need of authorization');
  next();
});

router.beforeEach((to, from, next) => {
  router.app.$log.info('Route info');
  router.app.$log.info(to);
  const pageTitle = to.matched.find(item => item.meta.title);
  if (pageTitle) {
    $store.commit('SET_TITLE', pageTitle.meta.title);
  }
  next();
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
});

export default router;
